import { VehicleIcon } from '../../core/models/vehicle-icon.model';

const ActionTypes = {
  GET_VEHICLE_ICONS: `[VEHICLE ICON] Get Vehicle Icons`,
  GET_VEHICLE_ICONS_SUCCESS: `[VEHICLE ICON] Get Vehicle Icons Success`,
  GET_VEHICLE_ICONS_FAIL: `[VEHICLE ICON] Get Vehicle Icons Fail`,
};

export class GetVehicleIconsAction {
  static type = ActionTypes.GET_VEHICLE_ICONS;
}

export class GetVehicleIconsSuccessAction {
  static type = ActionTypes.GET_VEHICLE_ICONS_SUCCESS;

  constructor(public payload: VehicleIcon[]) {
  }
}

export class GetVehicleIconsFailAction {
  static type = ActionTypes.GET_VEHICLE_ICONS_FAIL;

  constructor(public payload: any) {
  }
}
